var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingStarterQuiz1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 210,
    viewBox: "0 0 218 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c178dmjtia",
    x1: "0%",
    x2: "99.998%",
    y1: "49.991%",
    y2: "49.991%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "475hfrrp1b",
    x1: ".004%",
    x2: "100.01%",
    y1: "49.993%",
    y2: "49.993%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8mnckpn22c",
    x1: "-.001%",
    x2: "99.997%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pvq3nbytud",
    x1: "-.009%",
    x2: "99.993%",
    y1: "49.995%",
    y2: "49.995%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#020203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j20q6dxlfe",
    x1: "73.895%",
    x2: "25.982%",
    y1: "64.232%",
    y2: "31.644%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v5cwp4xabf",
    x1: "86.254%",
    x2: "25.285%",
    y1: "56.146%",
    y2: "22.932%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "06e0lzlk0g",
    x1: "92.951%",
    x2: "-4.792%",
    y1: "67.233%",
    y2: "41.273%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70 -31) translate(70 31)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.583,
    cy: 196.193,
    fill: "#DEE0E9",
    rx: 101.524,
    ry: 13.537
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6DA142",
    d: "M97.167 9.98C89.487 3.86 79.694.6 68.685.348l-.003-.004h-.212c-.816-.015-1.636-.018-2.463 0H49.021L55.478 1.4c-1.255.223-2.52.476-3.798.765-13.547 3.095-23.736 11.799-29.469 25.17-3.97 9.257-4.35 17.61-4.38 18.531-.09 2.813.842 5.422 2.463 7.467-1.91 1.625-9.124 4.336-9.124 4.336s12.186.793 18.095.007c6.084-.809 11.213-4.873 11.418-11.053.007-.186.794-18.673 16.097-22.17 10.961-2.506 20.243-1.295 26.14 3.406 4.863 3.878 7.329 10.064 7.332 18.388 0 9.698-11.985 18.834-22.558 26.893C57.57 80.854 48.83 87.516 46.478 97.057c-3.82 15.498-3.051 32.971-3.018 33.706.099 2.1.757 4.036 1.825 5.678-.98 1.35-7.57 3.066-8.125 5.2l17.71.01c.18 0 .36-.003.535-.01 6.304-.29 11.177-5.639 10.891-11.942-.007-.125-.46-10.833 1.248-21.534.655-4.098 2.788-7.811 5.956-10.493 2.554-2.162 5.62-4.496 8.049-6.348 13.32-10.152 31.57-24.054 31.566-45.08-.008-15.194-5.671-28.072-15.948-36.264zM47.093 146.085c-2.302-.428-7.083-.867-11.353.421l.549 28.346s7.62.696 11.923.107c.395-.055.794-.1 1.193-.118 6.062-.285 10.888-5.286 10.888-11.418v-5.495c0-5.802-4.325-10.599-9.93-11.334-1.093-.146-2.184-.304-3.27-.509z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7FBC4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.152 141.648c-6.065 0-11.122-4.768-11.407-10.888-.033-.736-.805-18.209 3.018-33.706 2.353-9.542 11.093-16.204 21.216-23.916 10.573-8.06 22.562-17.192 22.559-26.894 0-8.327-2.466-14.514-7.332-18.388-5.897-4.701-15.18-5.908-26.14-3.406-15.3 3.498-16.09 21.984-16.098 22.17-.205 6.18-5.279 11.053-11.418 11.053-.128 0-.256-.003-.384-.007C4.855 57.457-.088 52.17.12 45.863c.029-.922.413-9.274 4.379-18.53C10.233 13.965 20.422 5.26 33.97 2.163 51.852-1.925 68.005.848 79.452 9.976 89.73 18.168 95.392 31.05 95.396 46.24 95.4 67.266 77.155 81.168 63.83 91.32c-2.429 1.852-5.495 4.186-8.048 6.348-3.169 2.682-5.302 6.395-5.956 10.493-1.709 10.705-1.255 21.41-1.248 21.534.285 6.304-4.591 11.649-10.891 11.942-.18.007-.359.01-.535.01zM36.289 174.852c-6.315 0-11.43-5.118-11.43-11.429v-5.495c0-6.315 5.119-11.43 11.43-11.43 6.315 0 11.43 5.12 11.43 11.43v5.495c.003 6.311-5.115 11.43-11.43 11.43z",
    transform: "translate(103.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c178dmjtia)",
    d: "M10.013 19.965S19.511 3.538 45.596 1.123C71.678-1.29 81.022 15.45 81.022 15.45S58.13 5.48 39.523 10.427c-18.607 4.946-24.216 16.39-27.252 15.691-3.037-.706-5.034-2.517-2.258-6.153z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#475hfrrp1b)",
    d: "M4.562 31.566S.344 41.646 2.071 48.15c1.727 6.505 7.397 9.11 11.056 7.632 3.658-1.482-8.565-24.216-8.565-24.216z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#8mnckpn22c)",
    d: "M31.423 130.215c-.33 1.642-2.641 1.745-3.113.139-.322-1.105-.542-2.345-.505-3.644.117-4.438 1.054-29.48 4.32-34.687 6.89-10.98 37.607-32.674 39.36-35.839 1.752-3.168 7.825-9.241 6.19-1.65-1.636 7.592-19.504 24.527-24.06 28.145-4.554 3.622-13.43 5.84-17.747 25.99-1.646 7.68-3.406 16.35-4.445 21.546z",
    transform: "translate(103.17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pvq3nbytud)",
    d: "M33.761 147.691s-5.294 1.559-6.93 5.997c-1.635 4.438-2.022 13.588 1.208 16.196 3.23 2.605 14.404-23.634 5.722-22.193z",
    transform: "translate(103.17)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M56.682 9.838s-1.793-2.777-5.598-1.786c-3.805.992-.34 6.44-1.98 7.504-1.638 1.065-1.73-1.068-3.032.432-1.299 1.5 1.482 6.78 6.216 4.57 4.738-2.21 4.394-10.72 4.394-10.72z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M61.884 7.833s.088-1.98-2.572-2.012c-2.66-.03-4.749 2.692-4.54 7.174.208 4.485 2.407 5.385 3.907 5.261 1.5-.128 5.426-2.663 6.015-5.107.585-2.437-.67-5.375-2.81-5.316z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M66.34 22.92L79.405 39.06s-2.495-13.49-1.376-18.03c1.12-4.54 4.383-2.195 5.298 2.697.918 4.891 9.022 21.779 1.222 25.679-9.172 4.584-16.251-7.767-17.375-10.815-1.12-3.047-.834-15.67-.834-15.67z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j20q6dxlfe)",
    d: "M5.184 10.701s.399 7.072 1.826 8.342c1.427 1.27-2.69 1.372-3.6-.132-.911-1.507-1.573-8.334-1.573-8.334l3.347.124z",
    transform: "translate(33.659 41.341) translate(76.098 2.561)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003063",
    d: "M2.298 4.683c1.104.007 2.63-.011 4.328-.12l-.275 7.521c-1.427-.42-2.916-.764-4.434-.98C.97 10.968.278 10.138.315 9.179l.098-2.692c.037-1.01.871-1.811 1.885-1.804z",
    transform: "translate(33.659 41.341) translate(76.098 2.561)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v5cwp4xabf)",
    d: "M19.196.274l-.592 17.748s-5.261-3.87-12.25-5.934l.275-7.522c4.767-.307 9.53-2.693 12.567-4.292z",
    transform: "translate(33.659 41.341) translate(76.098 2.561)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003063",
    d: "M17.107 9.055c-.183 4.957.608 9.007 1.767 9.051 1.156.044 2.243-3.94 2.426-8.897C21.483 4.25 20.693.2 19.533.157c-1.16-.04-2.243 3.944-2.426 8.898z",
    transform: "translate(33.659 41.341) translate(76.098 2.561)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#06e0lzlk0g)",
    d: "M23.872 10.946l-6.772.608c-.026-.794-.022-1.632.011-2.495.044-1.164.135-2.276.267-3.293l6.596.885c1 .136 1.735 1.006 1.698 2.012l-.015.403c-.04.988-.805 1.793-1.785 1.88z",
    transform: "translate(33.659 41.341) translate(76.098 2.561)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M17.107 9.055c.044-1.164.136-2.276.267-3.293l.824.11.5 5.532-1.602.142c-.022-.79-.022-1.624.011-2.491zM3.274 9.417c.955.285 2.17.596 3.143.838l-.066 1.833c-1.427-.42-2.916-.765-4.434-.98C.97 10.971.278 10.14.311 9.182l.048-1.266c.731.505 1.821 1.17 2.915 1.5z",
    transform: "translate(33.659 41.341) translate(76.098 2.561)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M62.48 13.837c.048-.205.063-.414.066-.622.008-.4.11-.992.695-.692.857.436.707 2.561-.285 2.707-.732.11-.596-.878-.476-1.393zM57.27 15.809l-.585 6.12c-.091 1.01 2.177 3.809 3.875 2.664.497-.337 0-1.771-.351-2.858l-.761-5.363-2.177-.563z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001437",
    d: "M59.898 19.559c-1.28-.513-2.437-2.594-2.437-2.594l2.093.175.344 2.419z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M57.6 11.883l-.563 2.323c-.447 1.84.589 3.79 2.422 4.273 1.69.447 3.428-.402 3.863-2.546.388-1.91-.842-3.684-1.266-4.599-.962-2.082-3.61-2.074-4.456.549z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M57.051 14.13c-.058-.202-.088-.41-.106-.619-.033-.399-.172-.98-.739-.644-.827.49-.541 2.601.454 2.685.742.063.541-.914.391-1.423z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.601 15.38s.962.161 2.283-.11c0 0-.256.981-.757 1.325s-1.13-.201-1.526-1.215z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M59.73 17.73c.702.08 1.979-.096 2.531-.48.49-.344.973-1.23 1.076-1.423-.008.036-.008.07-.015.106-.435 2.147-2.173 2.996-3.863 2.546-1.127-.3-1.954-1.156-2.316-2.199.881.985 1.953 1.38 2.586 1.45z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211B40",
    d: "M71.982 51.227c-2.023-7.467-2.353-9.472-2.912-13.178-.611-4.032 3.11-5.269 1.423-9.271-.487-1.156-2.671-3.428-2.938-4.28-1.325-4.197-10.83-5.174-16.087-2.225-3.662 2.053-.05 13.167-1.163 15.542-1.332 2.842-4.288 6.417-7.076 11.755 4.804 1.086 19.028 3.914 28.753 1.657z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M61.291 26.407c3.169.311 5.057.114 4.672-1.81-.252-1.267-1.81-2.55-3.49-3.63-2.363-.538-5.13-.582-7.701.062.46 1.28 3.801 5.111 6.52 5.378zM83.005 96.45c1.73-22.452-10.965-45.007-11.02-45.223-9.724 2.26-23.948-.57-28.752-1.661-.904 1.73-1.793 3.647-2.601 5.788-4.387 11.608 4.76 33.073 1.547 48.64-2.96 14.341-.238 37.855 1.343 40.412 1.354 2.012 3.395 2.715 5.444-.713 3.08-5.155 9.545-38.869 12.399-69.033 5.403 10.507 4.946 15.97 4.946 25.866 0 3.914.827 32.78 5.382 43.591.856 2.034 2.605 1.496 3.944 1.134 4.898-1.317 6.256-34.408 7.368-48.801zM54.454 23.43c-1.361-4.117-20.77 2.805-26.419.808-5.648-1.998-16.1-21.63-21.53-19.273C1.075 7.32 11 24.644 18.98 30.637c6.846 5.14 17.422 4.145 23.104 2.733 5.686-1.42 13.866-5.422 12.37-9.94z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M83.005 96.45c1.174-15.241-4.295-30.523-7.95-38.839-.966 2.393-2.023 6.882-.743 13.756 2.042 10.95 6.033 16.332 4.826 26.074-1.208 9.743-7.423 14.196-5.938 24.498 1.032 7.167.582 17.433 1.244 23.609.41-.07.816-.183 1.189-.286 4.902-1.328 6.26-34.42 7.372-48.812zM55.013 82.273c-1.298 6.922-1.95 22.493-3.431 28.99-1.486 6.494-2.506 17.909-3.805 23.569-1.017 4.434-1.123 7.781.036 10.379.38-.37.765-.87 1.153-1.515 3.055-5.114 9.435-38.316 12.33-68.286-1.431-1.427-4.984-.055-6.283 6.863z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M70.002 147.845c.666-.907 1.054-1.884 1.292-2.82.289-1.135 1.193-2.002 2.345-2.225.999-.194 2.1-.256 2.641.234 1 .904.403 2.356 1.2 3.74.348.603 7.596 4.624 7.665 5.432.117 1.35-13.778.787-16.039-.6-1.182-.724-.282-2.155.896-3.76zM42.227 147.227c.666-.907 1.053-1.884 1.291-2.82.29-1.135 1.193-2.002 2.345-2.225 1-.194 2.1-.256 2.642.234.999.904.402 2.356 1.2 3.739.347.604 7.595 4.624 7.665 5.433.117 1.35-13.779.786-16.04-.6-1.181-.725-.281-2.155.897-3.761z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M78.296 20.166s-.622-1.738.26-2.503c.882-.764 1.39-.325 1.972-.79.582-.464.86.417.395.79-.464.37-1.068.469-1.043.79.022.323.1 2.92-1.584 1.713z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M82.639 16.72s-.37-.703-1.207-.564c-.834.14-1.925.424-1.482.959.439.534.787.526.787.526s.453 2.05 1.112 2.32c.662.27 1.72-.589.79-3.241z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CC00",
    d: "M71.982 51.227c-9.725 2.26-23.95-.57-28.753-1.661-.903 1.73-1.792 3.647-2.601 5.788-3.037 8.03.406 20.776 1.752 33.025 2.865.392 9.593 1.153 17.353.955 2.034-.051 4.141-.168 6.267-.377 5.766-.563 11.682-1.785 16.73-4.148-2.041-18.004-10.7-33.407-10.748-33.582z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3AF00",
    d: "M71.982 51.227c-3.59.834-7.79.973-11.902.764-.058 1.822.121 4.003.685 6.6 2.44 11.258 8.381 9.772 8.626 20.166.081 3.311.498 6.637 1.032 9.63 4.303-.696 8.547-1.822 12.311-3.578C80.69 66.805 72.03 51.402 71.982 51.227z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F18987"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.382 1.694c-.03 0-.062-.004-.092-.015-.146-.051-.223-.208-.172-.355.234-.665.388-1.042.395-1.057.059-.143.224-.208.363-.15.142.059.208.223.15.362 0 .004-.158.38-.385 1.028-.036.114-.142.187-.26.187zM3.161 32.81c-.132 0-.249-.095-.274-.23-.121-.67-.253-1.417-.392-2.221-.025-.15.077-.297.227-.322.154-.026.296.076.322.226.139.805.27 1.552.391 2.221.026.15-.073.296-.223.322-.018.004-.036.004-.051.004zm-.772-4.442c-.132 0-.252-.095-.274-.23-.121-.72-.245-1.467-.37-2.225-.025-.15.077-.296.23-.318.15-.025.297.077.319.23.124.758.245 1.504.366 2.221.025.15-.077.297-.227.322-.015-.003-.03 0-.044 0zm-.72-4.452c-.136 0-.253-.099-.275-.234-.117-.747-.227-1.493-.337-2.232-.022-.154.084-.293.234-.315.15-.022.293.085.315.235.106.739.22 1.481.333 2.228.022.153-.08.292-.234.318h-.037zm-.648-4.46c-.14 0-.256-.102-.275-.241-.106-.798-.2-1.555-.278-2.243-.018-.154.092-.29.245-.307.154-.019.29.091.308.245.077.684.172 1.438.278 2.231.022.154-.088.293-.238.311-.015 0-.03.004-.04.004zM.52 14.974c-.143 0-.264-.11-.279-.256-.043-.512-.073-.984-.095-1.4-.014-.283-.022-.575-.025-.868 0-.154.12-.278.274-.282H.4c.153 0 .278.125.278.275.003.285.01.57.022.848.018.414.051.879.091 1.383.011.154-.102.29-.256.3H.52zm-.037-4.5H.46c-.154-.01-.267-.146-.256-.3.058-.731.146-1.492.263-2.257.022-.154.165-.256.319-.234.153.022.256.165.234.318-.114.75-.201 1.497-.26 2.217-.011.147-.132.256-.278.256zm.677-4.448c-.019 0-.04-.004-.059-.008-.15-.033-.245-.183-.212-.333.161-.728.348-1.47.552-2.198.04-.147.198-.235.344-.194.147.04.235.194.194.344-.205.72-.388 1.448-.545 2.17-.033.13-.146.219-.274.219zM3.765 36.099c-.132 0-.25-.092-.275-.227 0 0-.077-.399-.205-1.094-.029-.15.074-.296.224-.326.15-.029.296.074.325.224.128.695.205 1.094.205 1.094.03.15-.07.296-.223.325-.018.004-.037.004-.051.004z",
    transform: "translate(33.659 41.341) translate(42.805 50.854)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AE283E",
    d: "M54.607 24.93c-1.745.629-7.2 4.459-11.937 6.255-5.382 2.042-8.104-.186-12.879-1.61-4.774-1.423-9.021-2.04-11.557-4.207-2.535-2.166-1.855-3.033-5.63-7.298-3.776-4.266-3.03-5.013-3.59-7.596-.555-2.583-1.423-3.786-3.54-4.653-2.792 4.244 6.175 19.306 13.503 24.808 6.845 5.14 17.422 4.145 23.103 2.733 5.05-1.251 12.059-4.547 12.527-8.433z",
    transform: "translate(33.659 41.341)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC6265",
    d: "M7.226 4.13S6.402 2.444 6.22 1.815c-.18-.633-.374-2.2-.922-1.113-.55 1.083.281 2.027-.615 2.166C3.787 3.011 2.799 2.1.97 1.277.124.897-.512 2.9 1.13 4.317c1.961 1.687 3.875 2.477 5.016 2.265 2.466-.465 1.08-2.452 1.08-2.452z",
    transform: "translate(33.659 41.341)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingStarterQuiz1);
export default __webpack_public_path__ + "static/media/landing-starter-quiz-1.1878341b791bb87d3fe67e79a55ae8a2.svg";
export { ForwardRef as ReactComponent };